import React from 'react';
import { Box } from '@mui/material';

const getDefaultWrenUrl = () => {
  return '/wren/';
};

const WrenEmbedPage = () => {
  const wrenUrl = process.env.REACT_APP_WREN_UI_URL || getDefaultWrenUrl();

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        position: 'absolute',
        inset: 0,
        bgcolor: '#fff',
        overflow: 'hidden',
      }}
    >
      <iframe
        title="Wren AI"
        src={wrenUrl}
        style={{
          width: '100%',
          height: '100%',
          border: 0,
          display: 'block',
        }}
        sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-top-navigation-by-user-activation"
        allow="clipboard-read; clipboard-write; fullscreen"
      />
    </Box>
  );
};

export default WrenEmbedPage;
